import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getMeetings } from 'actions/meetings';
import Card, { CardFooter, CardsContainer, CardTitle } from 'components/Presentation/Cards/Card';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPageTitle } from 'actions/header';
import { Tabs, Tab, translate } from '@haldor/ui';
var MyMeetings = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function MyMeetings(props) {
    var _this;
    _classCallCheck(this, MyMeetings);
    _this = _callSuper(this, MyMeetings, [props]);
    /* Lifecycle methods */
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.getMeetings();
    });
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      var translate = _this.props.translate;
      _this.props.setPageTitle(translate('Meetings'));
    });
    _this.state = {
      modal: false
    };
    return _this;
  }
  _inherits(MyMeetings, _Component);
  return _createClass(MyMeetings, [{
    key: "render",
    value: /* Render methods */
    function render() {
      var current = [];
      var past = [];
      if (this.props.meetings != null) {
        current = this.props.meetings.filter(function (meeting) {
          return meeting.instances[0].status == 'ACTIVE' && meeting.status != 'COMPLETED';
        });
        past = this.props.meetings.filter(function (meeting) {
          return meeting.status == 'COMPLETED' || meeting.instances[0].status == 'COMPLETED';
        });
      }
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "page"
      }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: translate('Current meetings'),
        route: "current"
      }, /*#__PURE__*/React.createElement(CardsContainer, null, current.map(function (meeting) {
        var instance = meeting.instances[0];
        return /*#__PURE__*/React.createElement(Card, {
          type: "group",
          key: meeting.id,
          id: meeting.id,
          target: "/meetings/".concat(meeting.id, "/instance/").concat(instance.id)
        }, /*#__PURE__*/React.createElement(CardTitle, null, meeting.title), /*#__PURE__*/React.createElement(CardFooter, null));
      }))), /*#__PURE__*/React.createElement(Tab, {
        title: translate('Previous meetings'),
        route: "past"
      }, /*#__PURE__*/React.createElement(CardsContainer, null, past.map(function (meeting) {
        var instance = meeting.instances[0];
        return /*#__PURE__*/React.createElement(Card, {
          type: "group",
          key: meeting.id,
          id: meeting.id,
          target: "/meetings/".concat(meeting.id, "/instance/").concat(instance.id)
        }, /*#__PURE__*/React.createElement(CardTitle, null, meeting.title), /*#__PURE__*/React.createElement(CardFooter, null));
      })))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    meetings: state.Meetings.meetings,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getMeetings: getMeetings
})(MyMeetings);